import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import React from "react";
import { Title } from "react-admin";
import { Helmet } from "react-helmet";
import CreateAdhocInvoiceByCsvButton from "./components/CreateAdhocInvoiceByCsvButton";
import UnapprovedInvoiceTable from "./components/UnapprovedInvoiceTable";

const UnpostedInvoiceList = () => {
  return (
    <>
      <Helmet>
        <title>Unapproved Invoices</title>
      </Helmet>
      <Title title="Unapproved Invoices" />

      <SanitizedGrid container spacing={2}>
        <Grid item xs={6}>
          <Typography variant="h6">Unapproved Invoices</Typography>
        </Grid>
        <Grid item xs={6}>
          <CreateAdhocInvoiceByCsvButton />
        </Grid>

        <Grid item xs={12}>
          <UnapprovedInvoiceTable />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default UnpostedInvoiceList;
